<template>
  
    <v-app>
    <!-- Barra superior -->
    <v-app-bar color="#37495f" dark elevation="2">
      <v-app-bar-title>ImagingSoft © Gestión Documental</v-app-bar-title>
    </v-app-bar>

    <!-- Contenido del login -->
    <v-main>

   <v-container class="fill-height login-container" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">

    <v-img
      class="mx-auto my-6"
      max-width="228"
      src="../../public/login/logo.png"
    ></v-img>

    <v-card
      class="mx-auto pa-12 pb-8"
      elevation="8"
      max-width="448"
      rounded="lg"
    >
      <div class="text-subtitle-1 text-medium-emphasis">Usuario</div>

      <v-text-field
        density="compact"
        placeholder="O usuario de Sistema"
        prepend-inner-icon="mdi-account-outline"
        variant="outlined"
        v-model="usuario"
        @keyup.enter="logeo()"
      ></v-text-field>

      <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
        Contraseña

        <a
          class="text-caption text-decoration-none text-blue"
          rel="noopener noreferrer"
          @click.prevent="showForgotMessage = true"
        >
          ¿Has olvidado tu contraseña?</a>
      </div>

      <v-text-field
        :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
        :type="visible ? 'text' : 'password'"
        density="compact"
        placeholder="Introduce tu contraseña"
        prepend-inner-icon="mdi-lock-outline"
        variant="outlined"
        @click:append-inner="visible = !visible"
        v-model="password"
        @keyup.enter="logeo()"
      ></v-text-field>

      <v-card v-if="showForgotMessage"
        class="mb-12"
        color="surface-variant"
        variant="tonal"
      >    

        <v-card-text class="text-medium-emphasis text-caption">
          Importante: Contacte al administrador.
        </v-card-text>

      </v-card>

      <v-btn
        class="mb-8"
        color="#DC8560"
        size="large"
        variant="flat"
        block
        style="color: white;"
        @click.prevent="logeo()"
      >
        Ingresar
      </v-btn>

    </v-card>

     </v-col>
    </v-row>
  </v-container>

  </v-main>
  </v-app>

</template>
<script setup>
  import { ref } from 'vue'

  const visible = ref(false)
  const showForgotMessage = ref(false)

</script>

<script>
    import axios from '@/plugins/axios';
    import Swal from 'sweetalert2';

    export default {
     data() {
      return {
         usuario: '',
         password: '',
      };
     },

   methods: {

    async logeo() {
      
      var user = {
         usuario: this.usuario,
         password: this.password
      }

     try{
                  const response = await axios.post('/api/Users/login', user);              
                  //console.log('Respuesta completa del servidor:', response.data);     //Usarlo solo para ver los errores en el testeo de Software

                  // IMPORTANTE: Guardar los datos en localStorage
                  if (response.data.idUsuario) {
                    localStorage.setItem('idUsuario', response.data.idUsuario);
                    //console.log('IdUsuario guardado:', response.data.idUsuario);  //Usarlo solo para ver los errores en el testeo de Software
                  }

                    // ✅ Guardar el token JWT
                  if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    //console.log('Token guardado:', response.data.token);       //Usarlo solo para ver los errores en el testeo de Software
                  }
                  
                  localStorage.setItem('nombreUsuario', this.usuario);
                  //console.log('NombreUsuario guardado:', this.usuario);       //Usarlo solo para ver los errores en el testeo de Software
                  // ✅ Agregar esto - guardar los permisos
                  localStorage.setItem('Email', response.data.email);
                  localStorage.setItem('escaneo', response.data.escaneo);
                  localStorage.setItem('impresion', response.data.impresion);
                  localStorage.setItem('busqueda', response.data.busqueda)
                  localStorage.setItem('importacion', response.data.importacion);
                  localStorage.setItem('exportacion', response.data.exportacion);
                  localStorage.setItem('auditoria', response.data.auditoria)
                  localStorage.setItem('workflow', response.data.workflow);
                  localStorage.setItem('anotaciones', response.data.anotaciones);
                  localStorage.setItem('vinculacion', response.data.vinculacion);
                  

                  // Mostrar SweetAlert
                  await Swal.fire({
                    icon: 'success',
                    title: `¡Bienvenido, ${response.data.user?.Usuario || this.usuario}!`,
                    iconColor: '#ce501b',
                    text: 'Sesión iniciada correctamente',
                    timer: 2000,
                    confirmButtonColor: '#ce501b',
                    customClass: {
                      title: 'swal-title-custom',
                      confirmButton: 'swal-btn-confirmar',
                      container: 'swal-sobre-modal'
                    },
                    showConfirmButton: true
                  });

                   // Navegar DESPUÉS de que se cierre el SweetAlert
                   this.$router.push({ name: 'menuForm' });

     } catch (error) {
                //console.error('Error completo:', error);    //Usarlo solo para ver los errores en el testeo de Software
                
                if (error.response?.status === 401) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error de autenticación',
                    text: error.response.data?.mensaje || 'Usuario o contraseña incorrectos',
                  });
                } else if (error.response && error.response.data && error.response.data.message) {
                    Swal.fire({
                        icon: 'error',
                        iconColor: '#ce501b',
                        title: 'Error',
                        text: error.response.data.message,
                        customClass: {
                          title: 'swal-title-custom',
                          container: 'swal-sobre-modal'
                        }
                    });
                } else {
                    Swal.fire({
                      icon: 'error',
                      iconColor: '#ce501b',
                      title: 'Error de conexión',
                      text: 'No se pudo conectar con el servidor. Verifica que la API esté corriendo.',
                      customClass: {
                        title: 'swal-title-custom',
                        container: 'swal-sobre-modal'
                      }
                    });
                }
            }
    },


  }

}

</script>

<style scoped>
.login-container {
  min-height: calc(100vh - 64px);
  background-color: #E8E9F3; /* Color de la segunda imagen */
}

.v-main {
  background-color: #E8E9F3;
}
</style>

<style>
.swal-title-custom {
  color: #004d82 !important;
}

.swal-btn-confirmar {
  color: white !important;
}


</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>

<style>
.swal-sobre-modal {
  z-index: 10000 !important;
}
</style>